import React from 'react';

import './style.sass';

const ContentCaseBottom = ({ listTitle }) => {
    return (
        <div className="content-case__bottom">
            <div className="content-case__bottom-left">
                {listTitle.map((item, idx) => (
                    <div className="content-case__bottom-item" key={idx}>
                        <div
                            className="content-case__bottom-company"
                            dangerouslySetInnerHTML={{ __html: item.company }}
                        />
                        <a
                            href={item.companyLink}
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            className="content-case__bottom-link"
                            dangerouslySetInnerHTML={{ __html: item.companyLinkName }}
                        />
                        <div
                            className="content-case__bottom-text"
                            dangerouslySetInnerHTML={{ __html: item.text }}
                        />
                    </div>
                ))}
            </div>
            {listTitle[0].info ? (
                <div className="content-case__bottom-right">
                    {listTitle.map((item, idx) => (
                        <div className="content-case__bottom-block" key={idx}>
                            <div
                                className="content-case__bottom-info"
                                dangerouslySetInnerHTML={{ __html: item.info }}
                            />
                            <img
                                src={item.icon}
                                alt="WDAIcon"
                                className="content-case__bottom-img"
                            />
                        </div>
                    ))}
                </div>
            ) : (
                ''
            )}
        </div>
    );
};

export default ContentCaseBottom;
